import { Controller } from "stimulus"
import { showTarget, hideTarget } from '../../helpers/visibility'

export default class extends Controller {
  static targets = ["checkbox"]

  toggleAll(e) {
    console.log('here')
    const checked = e.target.checked
    this.checkboxTargets
      .filter(checkbox => checkbox.checked !== checked)
      .forEach(checkbox => checkbox.click())
  }
}

